'use strict';

angular.module('AcaApp').controller('ParticipantController', [
  '$rootScope',
  '$scope',
  '$timeout',
  'ParticipantService',
  'FormService',
  'UtilsService',
  '$mdDialog',
  'ShortcutsService',
  'currentParticipant',
  'LayoutService',
  'MsgBetweenCtrlService',
  'PARTICIPANT_FORM',
  /* jscs:disable maximumLineLength */
  function(
    $rootScope,
    $scope,
    $timeout,
    ParticipantService,
    FormService,
    UtilsService,
    $mdDialog,
    ShortcutsService,
    currentParticipant,
    LayoutService,
    MsgBetweenCtrlService,
    PARTICIPANT_FORM
    ){
    ShortcutsService.disableBackSpaceDefault();
    $scope.tinRequired = false;
    $scope.nameRequired = false;
    $scope.addressRequired = false;
    $scope.cityRequired = false;
    $scope.stateRequired = false;
    $scope.zipRequired = false;
    $scope.tinMaskedField = false;
    $scope.accountRequired = false;
    $scope.tinFieldId = 'tinField';
    $scope.color = false;
    $scope.validationsBE = false;
    $scope.validationFlag = false;
    $scope.isForeign = false;
    $scope.correctForm = 'N';
    $scope.rpcParticipant = {};
    $scope.formChanged = false;

    var init = function(){
      if(currentParticipant !== undefined){
        if(currentParticipant.warnings !== undefined){
          if(currentParticipant.warnings !== ''){
            $scope.validationMessage = UtilsService.errorMessageValidationForString(currentParticipant.warnings);
            $scope.validationsBE = true;
          }
        }
        $scope.participantAction = 'edit';
        currentParticipant.birthdate = checkBirthdate(currentParticipant.birthdate);
        $scope.form = currentParticipant;
        $scope.form.disabled = true;
        $scope.changeValueAndColor();
        $scope.setTinMask();
        $scope.tinMaskedField = true;
        $scope.isForeign = (currentParticipant.foreigncountryind === '1');
        $scope.form.tinWithoutSuffix = currentParticipant.tinWithoutSuffix || $scope.form.tin.split(' ')[0];
        $scope.info2Selected = (currentParticipant.info2) ? currentParticipant.info2.split(',') : '';
        MsgBetweenCtrlService.data.participant = $scope.form;
        if(($scope.form.oldTinWithoutSuffix || $scope.form.tinWithoutSuffix) !== $scope.form.tinWithoutSuffix){
          $scope.formChanged = true;
        }
        if(($scope.form.oldAccountno || $scope.form.accountno) !== $scope.form.accountno){
          $scope.formChanged = true;
        }
      }
      else{
        $scope.form = {};
        $scope.participantAction = 'add';
      }
    };

    var _formChanged = function(newValue, oldValue){
      if(newValue !== oldValue){
        $scope.formChanged = true;
      }
    };

    $scope.$watch('form', _formChanged, true);

    $scope.enableSave = function(){
      $scope.formChanged = true;
    };

    $scope.changeValueAndColor = function(){
      if($scope.form.birthdate){
        $scope.color = true;
      }
      else{
        $scope.color = false;
      }
    };

    $scope.setTinMask = function(){
      $scope.form.tinmask = ParticipantService.maskTin($scope.form.tin);
    };

    $scope.showUnMaskedTin = function(){
      $scope.tinMaskedField = false;
      $timeout(function(){
        $('#' + $scope.tinFieldId).focus();
      }, 10);
    };

    $scope.validateFields = function(field){
      if(field === 'editTin' && !$scope.form.tin){
        $scope.tinRequired = false;
      }
      else{
        if(field === 'editTin' || !field){
          $scope.tinRequired = false;
        }
      }
      if(field === 'editAccount' || !field){
        $scope.accountRequired = true;
      }
      if(field === 'editName' || !field){
        $scope.nameRequired = true;
      }
      if(field === 'editAddress' || !field){
        $scope.addressRequired = true;
      }
      if(field === 'editCity' || !field){
        $scope.cityRequired = ($scope.isForeign === false);
      }
      if(field === 'editState' || !field){
        $scope.stateRequired = ($scope.isForeign === false);
      }
      if(field === 'editZip' || !field){
        $scope.zipRequired = true;
      }
      $scope.errorMessage = '';
    };

    $scope.closeModal = function(){
      $scope.validationFlag = false;
      closeModal();
    };

    var closeModal = function(){
      ShortcutsService.enableBackSpaceDefault();
      $mdDialog.hide();
    };

    $scope.addParticipant = function(form, action){
      $scope.rpcParticipant = {
        tin: $scope.form.tin,
        accountno: $scope.form.accountno,
        tintype: 2,
        name: $scope.form.name,
        middlename: $scope.form.middlename,
        name2: $scope.form.name2,
        namesuffix: $scope.form.namesuffix,
        address: $scope.form.address,
        address2: $scope.form.address2,
        city: $scope.form.city || PARTICIPANT_FORM.NO_CITY,
        state: $scope.form.state,
        zip: $scope.form.zip,
        birthdate: $scope.form.birthdate || null,
        rescountrycode: $scope.form.rescountrycode,
        foreignprovince: $scope.form.foreignprovince,
        foreigncountryind: ($scope.isForeign) ? '1' : '_',
        info2: ($scope.form.selectedStates) ? $scope.form.selectedStates.join(',') : '_'
      };
      if(form.$valid){
        switch(action){
          case 'add':
            saveParticipant();
            break;
          case 'edit':
            areThereFormsMarkedAsPrinted();
            break;
        }
      }
      else{
        $scope.validateFields();
      }
    };

    var saveParticipant = function(){
      ParticipantService.addParticipant($scope.rpcParticipant, $scope.validationFlag).then(
        function(data){
          if(data.result.DataBool){
            $scope.validationFlag = false;
            setCleanParticipant(data.result.UpdatedFields);
            $mdDialog.hide();
            $mdDialog.show({
              locals: {
                form: $scope.form
              },
              controller: [
                '$scope',
                'form',
                '$mdDialog',
                '$route',
                function($scope, form, $mdDialog, $route){
                  $scope.form = form;
                  $scope.titleUI = 'Creation';
                  $scope.descriptionUI = 'created';
                  $scope.closeModal = function(){
                    closeModal();
                    $route.reload();
                  };
                }
              ],
              templateUrl: 'app/views/participant/modals/createConfirmation.html'
            });
          }
          else{
            enabledError(data.result);
          }
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
        }
      );
    };

    var getTin = function(tin, tinWithoutSuffix){
      return tin.split(' ')[0] === tinWithoutSuffix ? tin : tinWithoutSuffix;
    };

    var updateParticipant = function(){
      $scope.rpcParticipant.tin = getTin($scope.form.tin, $scope.form.tinWithoutSuffix);
      $scope.rpcParticipant.seghash = currentParticipant.seghash;
      $scope.rpcParticipant.datemodified = currentParticipant.datemodified;
      $scope.rpcParticipant.modid = currentParticipant.modid;
      $scope.rpcParticipant.modrecno = currentParticipant.modrecno;
      $scope.rpcParticipant.modlevel = currentParticipant.modlevel;
      $scope.rpcParticipant.datemodified = currentParticipant.datemodified;
      $scope.rpcParticipant.recordversion = currentParticipant.recordversion;
      $scope.rpcParticipant.info2 = (currentParticipant.selectedStates) ? $scope.form.selectedStates.join(',') : '_';
      if($scope.rpcParticipant.city == ''){
        $scope.rpcParticipant.city = PARTICIPANT_FORM.NO_CITY;
      }
      ParticipantService.Update($scope.rpcParticipant, $scope.validationFlag, $scope.correctForm, $scope.form.allAccounts ? 'Y' : 'N').then(
        function(data){
          if(data.result.DataBool){
            setCleanParticipant(data.result.UpdatedFields);
            $rootScope.isRefresh = 'updateParticipant';
            $scope.validationFlag = false;
            $mdDialog.hide();
            $mdDialog.show({
              locals: {
                form: $scope.form
              },
              controller: [
                '$scope',
                'form',
                '$mdDialog',
                function($scope, form, $mdDialog){
                  $scope.form = form;
                  $scope.titleUI = 'Update';
                  $scope.descriptionUI = 'updated';
                  $scope.closeModal = function(){
                    closeModal();
                  };
                }
              ],
              templateUrl: 'app/views/participant/modals/createConfirmation.html'
            });
          }
          else{
            $scope.reprintCancel();
            enabledError(data.result);
          }
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
        }
      );
    };

    var setCleanParticipant = function(nameClean){
      var participantData = UtilsService.csvStringToObject(nameClean);

      $scope.form.name = participantData.name;
      $scope.form.middlename = participantData.middlename;
      $scope.form.name2 = participantData.name2;
    };

    $scope.reprintCancel = function(){
      $mdDialog.show({
        templateUrl: PARTICIPANT_FORM[UtilsService.getTaxYear()],
        onComplete: function(){
          $scope.participantForm.$setDirty();
        },
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.reprintYes = function(){
      $mdDialog.hide();
      $scope.correctForm = 'Y';
      updateParticipant();
    };

    $scope.reprintNot = function(){
      $mdDialog.hide();
      $scope.correctForm = 'N';
      updateParticipant();
    };

    var areThereFormsMarkedAsPrinted = function(){
      FormService.AreThereFormsMarkedAsPrinted($scope.rpcParticipant.tin).then(
        function(data){
          if(data.result.value && !$scope.validationFlag){
            $mdDialog.show({
              templateUrl: 'app/views/participant/modals/updateConfirmation.html',
              scope: $scope,
              preserveScope: true
            });
          }
          else{
            updateParticipant();
          }
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
        }
      );
    };

    var checkBirthdate = function(birthdate){
      return birthdate ? UtilsService.getUnixTimestamp(birthdate).split(' ')[0] : '';
    };

    init();

    $scope.evaluate = function(value1, value2){
      return LayoutService.selectedItemToUpperCase(value1, value2);
    };

    var enabledError = function(error){
      $scope.validationFlag = true;
      $scope.validationMessage = UtilsService.errorMessageValidationForString(error.ErrorMessage);
      $scope.validationsBE = true;
    };

    LayoutService.addDatepicker('#datepicker');

    $scope.showChangeSSN = function(){
      $mdDialog.show({
        preserveScope: true,
        templateUrl: 'app/views/participant/modals/change-ssn.html',
        controller: 'SsnModalController',
        controllerAs: 'vm'
      });
    };

    $scope.showChangeAcct = function(){
      $mdDialog.show({
        preserveScope: true,
        templateUrl: 'app/views/participant/modals/change-account.html',
        controller: 'AccountModalController',
        controllerAs: 'vm'
      });
    };

    $scope.checkProvince = function(event){
      return UtilsService.checkAlphaNumSpecCharacter(event);
    };

    $scope.states = UtilsService.getStates();

    $scope.checkInfo2States = function(key){
      var isSelected = false;
       _.each($scope.info2Selected, function(state){
        if(state === key ){
          isSelected =  true;
        }
      });

      return isSelected;
    }
  }
]);
